import React, { useEffect, useState } from 'react';
import api from '../../common/api';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/styles/makeStyles";
import { MaterialTable } from '../../components';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles(theme => ({
    root: props => ({
        margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
}));

const MedicineStorageOverviewPage = ({ showError, showMessage }) => {
    const [medicineStorage, setMedicineStorage] = useState([]);
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });
    const classes = useStyles({ isDesktop });

    const getAllMedicineStorage = () => {
        setLoading(true);
        showError('');
        showMessage('');
        const response = api.post('/medicine-global-storage');
        response.then(res => {
            setMedicineStorage([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Medicine Storage Found');
                else
                    showError(err.message);
            } else {
                showError('Unknown Error');
            }
        }).finally(() => {
            setLoading(false);
        });
        return response;
    };

    useEffect(() => {
        Promise.all([getAllMedicineStorage()]).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.root}>
            <Grid container justify='space-between' alignItems='flex-end' className={classes.topBar}>
                <Grid>
                    <Typography display="block" variant="h3" gutterBottom>
                        Medicine Storage Overview
                    </Typography>
                </Grid>
            </Grid>
            <MaterialTable
                isLoading={loading}
                columns={[
                    { title: 'id', field: 'id', hidden: true },
                    { title: 'Material Type', field: 'materialType', hidden: false, editable: 'never' },
                    { title: 'Material Name', field: 'materialName', hidden: false, editable: 'never' },
                    { title: 'Available Quantity', field: 'availableStorage', hidden: false, editable: 'never' },
                ]}
                title='Medicine Storage Overview'
                data={medicineStorage}
                options={{
                    actionsColumnIndex: -1,
                    search: true,
                    showTitle: true,
                    toolbar: true
                }}
            />
        </div>
    );
};

export default MedicineStorageOverviewPage;
